var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7817 23.3348L18.6133 16.0611C21.7758 11.5281 20.7217 5.30822 16.2942 2.04028C11.8667 -1.12224 5.75241 -0.17338 2.48448 4.25415C2.48448 4.35956 2.37909 4.35977 2.37909 4.46519C-0.783418 8.99813 0.165412 15.2175 4.69834 18.4855C8.28252 21.0155 13.0262 21.0153 16.505 18.2744L23.6734 25.4431L25.7817 23.3348ZM10.4963 17.4313C6.59585 17.4313 3.43326 14.3742 3.43326 10.5792C3.43326 6.78416 6.49035 3.51602 10.2854 3.51602C14.0804 3.51602 17.3484 6.57312 17.3484 10.3681V10.4737C17.3484 14.2687 14.2913 17.3259 10.4963 17.4313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoupe);
export default __webpack_public_path__ + "static/media/ico_loupe.7b43b3cff0b008d1199c531154889b11.svg";
export { ForwardRef as ReactComponent };